// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2yxdC","badge":"style_badge__3RVFo","containerLoad":"style_containerLoad__Tbhra","visible":"style_visible__2PAbp"};